<template>
  <v-app>
    <v-app-bar v-if="!$route.meta.hideNavigation" app color="#962283" dark dense>
      <v-btn icon color="white" to="/">
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-spacer></v-spacer>
      <v-btn icon color="white" to="/tickets">
        <v-icon>mdi-ticket</v-icon>
        <span> View My Tickets</span></v-btn
      >

      <v-spacer></v-spacer>
      <v-btn icon color="white" to="/">
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <!-- <v-btn icon color="white" to="/Cart">
        <v-badge :content="cartItems" :value="cartItems" color="green" overlap>
          <v-icon>mdi-cart</v-icon>
        </v-badge>
      </v-btn> -->
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>

    <v-footer v-if="!$route.meta.hideNavigation" color="#962283" padless>
      <v-spacer></v-spacer>
      <v-btn icon color="white" to="/tickets">
        <v-icon>mdi-ticket</v-icon>
        View My Tickets</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn icon color="white" to="/">
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <!-- <v-btn icon color="white" to="/Cart">
        <v-badge :content="cartItems" :value="cartItems" color="green" overlap>
          <v-icon>mdi-cart</v-icon>
        </v-badge>
      </v-btn> -->
    </v-footer>  
  </v-app>
</template>

<script>
import db from "./data/Database";


export default {
  name: "App",

  components: {},

  data: () => ({
  }),
  created() {
    let Parameters = {}
    if (window.location.hostname === 'testtickets.ownurgoal.net.au' || window.location.hostname === 'localhost' ) {
      Parameters = {testing: 'true'}
    } 
    let query = window.location.search.substring(1).split("&");
    for (var i = 0, max = query.length; i < max; i++)
    {
        if (query[i] === "") // check for trailing & with no param
            continue;

        var param = query[i].split("=");
        Parameters[decodeURIComponent(param[0])] = decodeURIComponent(param[1] || "");
    }
    db.currentState.update(1, {
          Parameters: Parameters
        });
  },
  methods: {
    goHome() {
      location.reload();
    },
  },
  computed: {
  },
};
</script>
